<template>
  <!--面包屑导航-->
  <div class="current pt-15 pb-10 point">
    <div class="currentcon flex ai-center jc-betweet">
		<div class="flex ai-center">
		  <img class="home mr-10" src="../../assets/image/homeicon.png" alt="" />
		  <span class="pl-10 pr-10 fs-16 color-fontcol6" @click="goRouter('首页')">首页</span>
		  <template v-for="(item,index) in breadcrumbList">
		  <img class="next mr-10 ml-10" src="../../assets/image/nexticon.png" alt="" />
		  <span class="pl-10 pr-10 fs-16 color-fontcol6" @click="goRouter(item)" >{{item}}</span>
	
		 </template>
	    </div>
		<slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "headers",
  props: {breadcrumbList:Array,},
  data() {
    return {
      isActive: 0, //选中的导航id
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    //导航的鼠标滑过功能
    goRouter(nameTxt) {
		let that  = this
		this.$router.options.routes.forEach(function(item,index){
			if(nameTxt === item.nameTxt){
				that.$router.push(item.path)
			}
		})
    }, 
  },
};
</script>

<style lang="scss" scoped>
.current {
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 5px 5px -5px rgba(47, 48, 48, 0.2);
    position: fixed;
    left: 0;
    top: 185px;
    z-index:99999;
    .currentcon {
      width: 65%;
      margin: auto;
      .home {
        width: 20px;
        height: 20px;
      }
      .next {
        width: 10px;
        height: 20px;
      }
    }
  }
  </style>